import React, { useMemo } from 'react'

import { DepthKeys, useLanguages } from '@/hooks'
import { getImage } from '@/utils'

interface IDocumentsPageSchemaProps {
  title: string
  desc: string
  file?: string
  fileDesc?: DepthKeys
  fileTitle?: DepthKeys
}

export const DocumentsPageSchema: React.FC<IDocumentsPageSchemaProps> = ({
  desc,
  file,
  title,
  fileDesc,
  fileTitle,
}) => {
  const { t } = useLanguages()

  const fileUrl = useMemo(
    () => (file ? JSON.parse(file)?.[0]?.download_link : undefined),
    [file],
  )

  return (
    <div className="page-content">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="lease-title">
              <h1>{title}</h1>
            </div>
            <div
              className="lease-content start-reservation-content"
              dangerouslySetInnerHTML={{
                __html: `${
                  fileUrl
                    ? `
                    <a
                    rel="noopener"
                    target="_blank"
                    href=${getImage(`/${fileUrl}`, false)}
                  >
                    <table
                 style="
                  border-collapse: collapse;
                  width: 100%;
                  border-color: #ffffff;
                  border-style: hidden;
                  float: left;
                "
                border="1px solid"
              >
                <tbody>
                  <tr>
                    <td style="width: 5.39776%">
                      <img
                          style="
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                          "
                          src="/assets/img/pdf-icon.jpg"
                          alt="pdf icon"
                          width="28"
                          height="39"
                      />
                    </td>
                    <td style="width: 94.4602%">
                      <div>
                        ${fileTitle ? t(fileTitle) : ''}
                      </div>
                      <div>
                        ${fileDesc ? t(fileDesc) : ''}
                      </div>
                    </td>
                  </tr>
                  </tbody>
                  </table>
                  </a>
              <br></br>
              <br></br>
              <br></br>`
                    : ''
                }
              ${desc}`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
